// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchCell-cls1_4pB","cls2":"SearchCell-cls2_U9V SearchCell-cls1_4pB"};